import { useTranslation } from 'react-i18next'
import { fmt } from './format'

/** VH-222: logged energy balance vs. measured weight trend. */
export default function CompletenessNotice({ completeness }) {
  const { t } = useTranslation()
  if (!completeness) return null
  if (!completeness.computable) {
    return (
      <p className="text-sm text-gray-600" data-testid="completeness-not-computable">
        {t(`systemView.completeness.reasons.${completeness.reason}`, { weighIns: completeness.weigh_ins, min: completeness.min_weigh_ins })}
      </p>
    )
  }
  const incomplete = completeness.log_likely_incomplete
  return (
    <div className={`border rounded-lg p-3 text-sm space-y-1 ${incomplete ? 'border-amber-300 bg-amber-50' : ''}`} data-testid="completeness">
      <p className="font-medium">{t('systemView.completeness.title')}</p>
      <p>{t('systemView.completeness.compare', {
        expected: fmt(completeness.expected_change_kg, 2), measured: fmt(completeness.measured_change_kg, 2),
        from: completeness.period_start, to: completeness.period_end,
      })}</p>
      {incomplete && (
        <p data-testid="completeness-gap">{t('systemView.completeness.gap', { kcal: fmt(completeness.unlogged_kcal_per_day, 0) })}</p>
      )}
      <p className="text-xs text-gray-600">{t('systemView.completeness.source')}</p>
    </div>
  )
}
